import { configureScope } from '@sentry/browser';
import Cohere from 'cohere-js';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * This integration creates a link from the Sentry Error to the Cohere Replay session.
 * Docs on Sentry SDK integrations are here: https://docs.sentry.io/platforms/javascript/advance-settings/#dealing-with-integrations
 */
var SentryCohere = /** @class */ (function () {
    function SentryCohere() {
        this.name = SentryCohere.id;
        this.replayStartTime = Date.now();
    }
    SentryCohere.prototype.setupOnce = function () {
        var sessionUrlListener = function (sessionUrl) {
            configureScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    event.contexts = __assign(__assign({}, event.contexts), { Cohere: {
                            'Cohere Session URL': "" + sessionUrl + (event.timestamp ? "?ts=" + event.timestamp * 1000 : ''),
                        } });
                    return event;
                });
            });
        };
        Cohere.addSessionUrlListener(sessionUrlListener);
    };
    SentryCohere.id = 'SentryCohere';
    return SentryCohere;
}());

export default SentryCohere;
